import { ref, computed } from 'vue'
import { getTreeExpandList, compileData } from '../../../utils/index'

export function useCheckbox(
  { tableRef, checkboxConfig, treeNode, checkboxBefore, extendCompileData },
  emit
) {
  const indeterminate = ref(false)
  const setIndeterminate = (val) => (indeterminate.value = val)
  const isIndeterminate = (checked) => {
    if (checked) {
      indeterminate.value = false
    }
    return indeterminate.value
  }

  const tableCheckboxConfig = computed(() => {
    const { enable, ...otherConfig } = checkboxConfig ?? {}
    if (enable !== undefined && !otherConfig?.checkMethod) {
      return {
        ...otherConfig,
        checkMethod: ({ row }) =>
          typeof enable === 'boolean' ? enable : compileData(enable, { ...extendCompileData, row }),
      }
    } else {
      return otherConfig
    }
  })
  // 设置选中项，排除复选框不能勾选的项
  const tableSetCheckboxRow = (rows, checked) => {
    rows = Array.isArray(rows) ? rows : [rows]
    const filterRows = !tableCheckboxConfig.value?.checkMethod
      ? rows
      : rows.filter((row) => tableCheckboxConfig.value?.checkMethod({ row }))
    tableRef.value.setCheckboxRow(filterRows, checked)
  }
  //设置全选，排除复选框不能勾选的项
  const tableSetAllCheckboxRow = (checked) => {
    const { fullData } = tableRef.value.getTableData()
    tableSetCheckboxRow(fullData, checked)
  }

  const checkboxChange = async (row, checked) => {
    const tempRow = checkboxBefore
      ? await checkboxBefore({ row, checked })?.catch((err) => ({ err }))
      : row
    if (tempRow && tempRow.hasOwnProperty('err')) {
      return
    }
    if (tableCheckboxConfig.value?.checkStrictly && row.children?.length > 0) {
      tableSetCheckboxRow(getTreeExpandList([row]), checked)
    } else {
      tableSetCheckboxRow(row, checked)
    }

    const records = tableRef.value.getCheckboxRecords()
    if (tableCheckboxConfig.value?.checkStrictly) {
      const { fullData } = tableRef.value.getTableData()
      const allData = getTreeExpandList(fullData)
      if (records.length === allData.length) {
        indeterminate.value = false
        //设置顶部复选框状态
        setAllCheckboxRow(true)
      } else {
        //设置顶部复选框状态
        setAllCheckboxRow(false)
      }
    }

    if (records.length > 0) {
      indeterminate.value = true
    } else {
      indeterminate.value = false
    }
    emit('checkbox-change', { records, row, checked })
  }
  const checkboxAll = async (checked) => {
    const tempRow = checkboxBefore
      ? await checkboxBefore({ checked })?.catch((err) => ({ err }))
      : null
    if (tempRow && tempRow.hasOwnProperty('err')) {
      return
    }

    tableSetAllCheckboxRow(checked)
    const { fullData } = tableRef.value.getTableData()
    //当设置父子不互相关联时需要父级联动子级，子级不要联动父级
    if (tableCheckboxConfig.value?.checkStrictly) {
      const allData = treeNode ? getTreeExpandList(fullData) : fullData
      tableSetCheckboxRow(allData, checked)
      //设置顶部复选框状态
      setAllCheckboxRow(checked)
    }

    const records = tableRef.value.getCheckboxRecords()
    emit('checkbox-all', {
      records,
      checked,
      fullData,
      allData: treeNode ? getTreeExpandList(fullData) : fullData,
    })
  }

  const setCheckboxRow = async (rows, checked) => {
    tableRef.value?.setCheckboxRow(rows, checked)
    const { fullData } = tableRef.value.getTableData()
    const allData = treeNode ? getTreeExpandList(fullData) : fullData
    const records = tableRef.value.getCheckboxRecords()
    if (records.length === 0 || allData.length === records.length) {
      indeterminate.value = false
    } else {
      indeterminate.value = true
    }
  }
  const setAllCheckboxRow = async (checked, expand) => {
    indeterminate.value = false
    tableRef.value?.setAllCheckboxRow(checked)
    if (expand) {
      const { fullData } = tableRef.value.getTableData()
      const allData = treeNode ? getTreeExpandList(fullData) : fullData
      setCheckboxRow(allData, checked)
    }
  }

  return {
    indeterminate, //表头复选框是否半选中
    setIndeterminate, // 设置表头复选框是否半选中
    isIndeterminate, // 表头复选框半选中
    checkboxChange, // 表格行级复选框事件
    checkboxAll, // 表头复选框事件
    setCheckboxRow, //设置选中行
    setAllCheckboxRow, //设置表格全选中
    tableCheckboxConfig, //复选框配置
  }
}
